const { ContactValidator } = require("./contactsValidator/contactsValidator");
const { ErrorResolver } = require("./errorResolvers/errorResolver");
const {
  VALIDATION_ERRORS,
  VALIDATION_WARNINGS
} = require("./validationErrors");

class ContactsService {
  constructor(contacts, userCountries) {
    this._totalErrors = {};
    this._optOutNumbers = [];
    this._contacts = [];
    this._validator = null;
    this._contacts = [];
    this._validator = new ContactValidator(userCountries);
    this._userCountries = userCountries;
    this._errorResolver = new ErrorResolver();
    if (contacts) {
      contacts.forEach(c => {
        c.phoneNumber = new PhoneNumber(
          c.phoneNumber.code,
          c.phoneNumber.number
        );
        this._contacts.push(c);
      });
    }
    Object.entries(VALIDATION_ERRORS).forEach(([key, value]) => {
      this._totalErrors[key] = 0;
    });
    Object.entries(VALIDATION_WARNINGS).forEach(([key, value]) => {
      this._totalErrors[key] = 0;
    });
  }

  setOptOutNumbers(phoneNumbers) {
    this._optOutNumbers = phoneNumbers.map(
      p => new PhoneNumber(p.code, p.number)
    );
  }

  _validate(contact) {
    contact.errors = this._validator.validate(contact);
    //Calculate total errors of each type
    contact.errors.forEach(e => {
      this._totalErrors[e]++;
    });
  }

  addContacts(contacts, ignoreExistingContacts = false) {
    var addedContacts = [];

    contacts.forEach(c => {
      var contact = this.mapContact(c);
      if (ignoreExistingContacts && this._alreadyContainsContact(c)) {
        return;
      }
      this._validate(contact);
      addedContacts.push(contact);
    });

    this._contacts.push(...addedContacts);

    this._checkDuplicates();
    this._checkOptOut(addedContacts);
  }

  _alreadyContainsContact(contact) {
    if (contact.externalReferences && contact.externalReferences.length > 0) {
      for (var i = 0; i < contact.externalReferences.length; ++i) {
        var newRef = contact.externalReferences[i];

        if (
          this._contacts.find(
            x =>
              x.externalReferences &&
              x.externalReferences.find(
                r =>
                  r.id && r.from && r.id === newRef.id && r.from === newRef.from
              )
          )
        ) {
          return true;
        }
      }
    }

    return false;
  }

  mapContact(c) {
    return {
      firstName: c.firstName?.trim(),
      lastName: c.lastName?.trim(),
      attributes: c.attributes,
      externalReferences: c.externalReferences,
      phoneNumber: !c.phoneNumber
        ? new PhoneNumber()
        : typeof c.phoneNumber === "object"
        ? new PhoneNumber(c.phoneNumber.code, c.phoneNumber.number)
        : new PhoneNumberMapper().map(c.phoneNumber)
    };
  }

  _onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  _checkDuplicates() {
    // var findDuplicates = (editedContacts) => editedContacts.filter((item) =>
    //     this._contacts.findIndex(x => x !== item && item.phoneNumber.fullNumber === x.phoneNumber.fullNumber) !== -1)
    var phoneComparer = (a, b) => {
      var aFullNumber = a.phoneNumber.getFullnumber();
      var bFullNumber = b.phoneNumber.getFullnumber();
      if (aFullNumber < bFullNumber) {
        return -1;
      }
      if (aFullNumber > bFullNumber) {
        return 1;
      }
      return 0;
    };

    var addDuplicateErrorToContact = contact => {
      if (contact.errors.indexOf(VALIDATION_ERRORS.DUPLICATE_CONTACT) == -1) {
        contact.errors.push(VALIDATION_ERRORS.DUPLICATE_CONTACT);
        this._totalErrors[VALIDATION_ERRORS.DUPLICATE_CONTACT]++;
      }
    };

    var sorted = this._contacts.slice().sort(phoneComparer);
    for (var i = 0; i < sorted.length - 1; i++) {
      if (
        sorted[i].phoneNumber.getFullnumber() ===
        sorted[i + 1].phoneNumber.getFullnumber()
      ) {
        addDuplicateErrorToContact(sorted[i]);
        addDuplicateErrorToContact(sorted[i + 1]);
      }
    }
  }

  _checkOptOut(contacts) {
    contacts.forEach(contact => {
      var optOut = this._optOutNumbers.find(
        optOutNumeber =>
          optOutNumeber.getFullnumber() === contact.phoneNumber.getFullnumber()
      );
      if (optOut) {
        if (!contact.errors.includes(VALIDATION_ERRORS.OPT_OUT_NUMBER)) {
          contact.errors.push(VALIDATION_ERRORS.OPT_OUT_NUMBER);
          this._totalErrors[VALIDATION_ERRORS.OPT_OUT_NUMBER]++;
        }
      }
    });
  }

  getContacts() {
    return this._contacts;
  }

  _clearValidationErrorsForIndex(index) {
    this._contacts[index].errors.forEach(e => {
      this._totalErrors[e]--;
      if (e === VALIDATION_ERRORS.DUPLICATE_CONTACT) {
        const duplicates = this._contacts.filter(
          contact =>
            contact.phoneNumber.getFullnumber() ===
            this._contacts[index].phoneNumber.getFullnumber()
        );
        if (duplicates.length === 2) {
          duplicates[0].errors.remove(VALIDATION_ERRORS.DUPLICATE_CONTACT);
          this._totalErrors[e]--;
        }
      }
    });
  }

  deleteContact(index) {
    this._clearValidationErrorsForIndex(index);
    this._contacts.splice(index, 1);
  }

  updateContact(index, firstName, lastName, phoneNumber) {
    this._clearValidationErrorsForIndex(index);

    const contact = this._contacts[index];
    contact.firstName = firstName;
    contact.lastName = lastName;
    contact.phoneNumber = new PhoneNumber(phoneNumber.code, phoneNumber.number);

    this._validate(contact);
    this._checkDuplicates();
    this._checkOptOut([contact]);
  }

  resolve(code,value) {
    var { toBeDeleted, edited } = this._errorResolver.resolve(
      this._contacts,
      code,
      value
    );
    toBeDeleted.forEach(c => {
      var index = this._contacts.findIndex(x => x === c);
      this.deleteContact(index);
    });
    this._totalErrors[code] = 0;

    if (edited.length > 0) {
      edited.forEach(c => {
        c.errors.forEach(e => {
          this._totalErrors[e]--;
        });
        this._validate(c);
      });

      this._checkDuplicates(edited);
      this._checkOptOut(edited);
    }
  }

  isValid() {
    return !this.hasErrors();
  }

  hasErrors() {
    return (
      Object.entries(this._totalErrors).filter(
        ([key, value]) => VALIDATION_ERRORS[key] && value > 0
      ).length > 0
    );
  }

  hasWarnings() {
    return (
      Object.entries(this._totalErrors).filter(
        ([key, value]) => VALIDATION_WARNINGS[key] && value > 0
      ).length > 0
    );
  }

  getTotalErrors() {
    return this._totalErrors;
  }
}

class PhoneNumberMapper {

  constructor(){
    this._regexCode = /^\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)/;
    this._regexNumbersOnly = /\s|\(|\)|-|\+/gi;
  }
  map(phoneNumber) {
    var number = phoneNumber ? phoneNumber.toString().replace(/\s/g, "") : "";
    var numberOnlyDigits = number.replace(this._regexNumbersOnly, "");
    var codes = this._regexCode.exec(number);
    var code = codes?.length > 1 ? codes[1] : undefined;
    var number = numberOnlyDigits.length > 0 ? numberOnlyDigits : undefined;

    if (number?.startsWith(code)) {
      number = number.replace(code, "");
    }

    if (number?.charAt(0) === "0") {
      number = number.substring(1);
    }

    return new PhoneNumber(code, number);
  }
}

Array.prototype.remove = function() {
  var what,
    a = arguments,
    L = a.length,
    ax;
  while (L && this.length) {
    what = a[--L];
    while ((ax = this.indexOf(what)) !== -1) {
      this.splice(ax, 1);
    }
  }
  return this;
};

const PhoneNumberFormater= (phoneNumber)=>{
   return phoneNumber.code
    ? `+${phoneNumber.code} ${phoneNumber.number ?phoneNumber.number : ""}`
    : phoneNumber.number ?phoneNumber.number: "";
}

class PhoneNumber {
  constructor(code, number) {
    this.code = code;
    this.number = number;
  }
  getFullnumber() {
    return `${this.code ?this.code: ""}${this.number ?this.number: ""}`;
  }
}
module.exports = { ContactsService, PhoneNumberMapper, PhoneNumberFormater };
